<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Translation Keys</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table 
                        show-empty
                        striped
                        :items="keys"
                        :fields="fields">
                        <template v-slot:cell(key)="row">
                           {{row.value}}
                       </template>
                        <template v-slot:cell(language)="row">
                           {{row.value}}
                           <span v-if="row.value == ''">
                               All Languages
                           </span>
                       </template>
                        <template v-slot:cell(languageCode)="row">
                           {{row.value}}
                           <span v-if="row.value == ''">
                               ALL
                           </span>
                       </template>
                        <template v-slot:cell(modify)="row">
                           <button class="btn btn-primary" @click="editKey(row.item.key)">Edit</button>
                       </template>
                        <template v-slot:cell(delete)="row">
                           <button class="btn btn-danger" @click="deleteKey(row.item.key)">Delete</button>
                       </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages" 
                    use-router 
                    align="center"
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')" >
                </b-pagination-nav>
                <button @click="addNewKey" class="btn btn-primary">Add New Key</button>
            </div>
        </div>
    </div>
</template>

<script>
import pagingMixin from './../../../mixins/pagingMixin';

export default {
    mixins: [ pagingMixin ],
    data () {
        return {
            keys: [],
            currentPage: null,
            totalKeys: 0,
            totalPages: 1,
        }
    },
    computed: {
        fields() {
            return [
                { key: 'key', label: 'Key', sortable: true },
                { key: 'language', label: 'Language' },
                { key: 'languageCode', label: 'Language Code' },
                { key: 'modify', label: 'Modify', tdClass: 'fit' },
                { key: 'delete', label: 'Delete', tdClass: 'fit' }
            ]
        },
    },
    methods : {
        getKeysCount: function(){
            this.$http.get('/api/languages/keys/count')
            .then(response => {
                this.totalKeys = response.data
                this.totalPages = this.calculateNumberOfPages(this.totalKeys);
            }).catch(error => {
                console.log(error)
            })
        },
        getAllKeys : function () {
            this.$http.get('/api/languages/keys')
            .then(response => {
                this.keys = response.data
            }).catch(error => {
                console.log(error)
            })
        },
        loadKeys: function () {
            this.$http.get('/api/languages/keys/' + this.currentPage)
            .then(response => {
                if (this.keys.length == 0) {
                    this.getKeysCount();
                }
                this.keys = response.data;
            }).catch(error => {
                console.log(error);
            })
        },
        editKey : function(key){
            this.$router.push(`/admin/languages/${key}/modify-key`)
        },
        deleteKey: function (key) {
            this.$http.delete(`/api/languages/${key}/delete`)
            .then(response => {
                let deleted = this.keys.findIndex(element => {
                    return element['key'] === key
                })
                this.loadKeys()
                this.getKeysCount()                
            })
        },
        addNewKey: function(){
            this.$router.push('/admin/translation-keys/add')
        },
        linkGeneration: function(pageNumber) {
            return {
                path: this.$route.path,
                query: { p: pageNumber }
            }
        }
    },
    created : function () {
       this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
    },
    watch: {
        currentPage: function (value) {
            this.getKeysCount();
            this.loadKeys();
        }
    }
}
</script>

<style>

</style>
